import styled from "styled-components";

/* El scroll aparece solo si la lista no cabe; el padding derecho evita que la
   barra se coma la sombra de las tarjetas.
   Con $fill la lista se estira hasta el fondo de su columna (así el panel
   termina a la misma altura que el chat); sin él se limita por su cuenta. */
export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
  padding-right: 2px;
  ${({ $fill }) => ($fill ? "flex: 1; min-height: 0;" : "max-height: 340px;")}
`;

export const Card = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.07);
  padding: 16px 18px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const Info = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Title = styled.div`
  color: #1b2b3a;
  font-size: 0.85rem;
  font-weight: 700;
  margin-bottom: 6px;
`;

export const Status = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 0.8rem;
  color: #55606b;
  margin-bottom: 6px;
`;

export const Dot = styled.span`
  width: 9px;
  height: 9px;
  border-radius: 50%;
  flex-shrink: 0;
  background: ${({ $tone }) =>
    $tone === "ready" ? "#2f80ed" : $tone === "confirmed" ? "#27ae60" : "#f2c94c"};
`;

export const When = styled.div`
  color: #1b2b3a;
  font-size: 0.85rem;
  font-weight: 700;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
  flex-shrink: 0;
`;

export const JoinButton = styled.button`
  padding: 7px 20px;
  border-radius: 6px;
  border: none;
  background: #1b6b78;
  color: #fff;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;

  &:hover { background: #175a65; }
  &:disabled { background: #c8d2d6; cursor: not-allowed; }
`;

export const CancelButton = styled.button`
  padding: 6px 18px;
  border-radius: 6px;
  border: 1.5px solid #c0392b;
  background: #fff;
  color: #c0392b;
  font-size: 0.8rem;
  cursor: pointer;

  &:hover { background: #fdf3f2; }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;
